import { singleton, inject } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

// domain
import { SemesterRepository } from "@/entities/semester/domain/repository";
import type { GetSemestersResponseDto } from "@/entities/semester/domain/dtos";

@singleton()
export default class SemesterRepositoryImpl implements SemesterRepository {
    constructor(@inject("HttpAdapter") private readonly server: HttpAdapter) {}

    /**
     * @description 학기 정보를 호출합니다.
     */
    public getSemester = async () => {
        const response = await this.server.get<GetSemestersResponseDto>(
            `/v1/semesters?include=MiddleUnit`,
        );

        return response;
    };
}
